import { Component, signal, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogContentBase, DialogModule, DialogRef } from '@progress/kendo-angular-dialog';
import { NotificationService } from '@progress/kendo-angular-notification';
import { CapitalizePipe } from '../../../pipes/capitalize.pipe';
import { FormErrorService } from '../../../services/serverError.service';
import { DialogResult } from '../../../types/DialogResult';

@Component({
  selector: 'rc-mercure-overtake-popup-action',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    CapitalizePipe,
    InputsModule,
    LabelModule,
    ComboBoxModule,
    ButtonsModule,
    DialogModule,
  ],
  providers: [FormErrorService, TranslatePipe, NotificationService],
  templateUrl: './mercure-overtake-popup-action.component.html',
  styleUrl: './mercure-overtake-popup-action.component.scss',
})
export class MercureOvertakePopupActionComponent extends DialogContentBase {
  user = signal<string | undefined>(undefined);
  details = signal<string>('');

  constructor() {
    const dialog = inject(DialogRef);

    super(dialog);
  }

  accept() {
    const val: DialogResult = { text: 'document-overtake', isSuccessFull: true };
    this.dialog.close(val);
  }

  openAsReadOnly() {
    const val: DialogResult = { text: 'document-readonly', readonly: true };
    this.dialog.close(val);
  }

  close() {
    const result: DialogResult = { text: 'cancel', isSuccessFull: false };
    this.dialog.close(result);
  }
}
